import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { NgxsModule } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { UserState } from './utiles/store/auth.state'; // Importer votre état d'authentification

import { CitizenHomeComponent } from './citizens/home-pages/citizen-home/citizen-home.component';
import { HeaderComponent } from './citizens/home-pages/citizen-home-header/header.component';
import { CitizenDashboardComponent } from './citizens/home-pages/citizen-dashboard/citizen-dashboard.component';
import { Citizen404NotFoundComponent } from './citizens/home-pages/citizen-404-not-found/citizen-404-not-found.component';
import { AppRoutingModule } from './app.routes';
import { JwtModule } from '@auth0/angular-jwt';
import { AuthGuardService } from './utiles/auth-guard/auth-guard-service.service';
import { AuthInterceptorService } from './utiles/auth-guard/auth-interceptor.service';
import { OAuthModule } from 'angular-oauth2-oidc';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { CitizenHomeFooterComponent } from './citizens/home-pages/citizen-home-footer/citizen-home-footer.component';
import { IntegerLengthGeoNUPDirective } from './shared/directives/input-nup-control.directive';
import { FormsModule } from '@angular/forms';
import { CitizenPublicationsComponent } from './citizens/home-pages/citizen-publications/citizen-publications.component';
import { SharedModule } from './shared/shared.module';
import { CitizenHomeLayoutComponent } from './citizens/home-pages/citizen-home-layout/citizen-home-layout.component';

registerLocaleData(localeFr);
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function tokenGetter() {
  return localStorage.getItem('access_token'); // Remplacez par votre méthode de récupération du token
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    CitizenHomeLayoutComponent,
    CitizenHomeComponent,
    CitizenPublicationsComponent,
    CitizenDashboardComponent,
    CitizenHomeFooterComponent,
    Citizen404NotFoundComponent,
    IntegerLengthGeoNUPDirective,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxsModule.forRoot([UserState]), // Ajouter vos états ici
    NgxsLoggerPluginModule.forRoot(), // Journalisation des actions
    NgxsReduxDevtoolsPluginModule.forRoot(), // Intégration avec les devtools Redux
    NgxsStoragePluginModule.forRoot({
      keys: [UserState], // Persistez seulement le token d'authentification
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: ['yourapi.com'], // Remplacez par le domaine de votre API
        disallowedRoutes: ['yourapi.com/auth/'], // Routes à ignorer pour l'ajout automatique du token
      },
    }),
    AppRoutingModule,
    OAuthModule.forRoot(),
    SharedModule,
  ],
  providers: [
    AuthGuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
